import { useMutation } from "@tanstack/react-query";
import { UserService } from "../../services/user.service";
import { IChangePasswordModel, IUpdateUserModel, IUser } from "../../models/User";

export const useUserMutations = () => {
  const { mutate: deleteUser } = useMutation<any, Error, any>({
    mutationFn: UserService.deleteUser,
  });

  const { mutate: updateUser } = useMutation<IUser, Error, IUpdateUserModel>({
    mutationFn: (data: IUpdateUserModel) => UserService.updateProfile(data).then((res) => res.data),
  });

  const { mutate: changePassword } = useMutation<
    boolean,
    Error,
    IChangePasswordModel & { id: string | null }
  >({
    mutationFn: (data: IChangePasswordModel & { id: string | null }) => {
      const { id, ...model } = data;
      return UserService.changePassword(data?.id, model).then((res) => res.data);
    },
  });

  return {
    deleteUser,
    updateUser,
    changePassword,
  };
};
